/* @flow */

export {RichTextarea} from './rich-textarea';
export {getMentionsConfig} from './get-mentions-config';
export type {MentionConfig} from './rich-textarea';
export type {Props as RichTextareaProps} from './rich-textarea';
